require("isomorphic-fetch");

import type { ErrorResponse, TokenResponse } from "src/types";

async function fetchJSON<T, E = ErrorResponse>(
  route: string,
  options: any = {
    method: "GET",
  }
): Promise<T | E> {
  const { body, method = "GET", headers = {}, ...rest } = options;

  const isFormData = method !== "GET" && body instanceof FormData;
  const contentType = isFormData
    ? {}
    : {
        "Content-Type": "application/json",
      };

  const response = await fetch(route, {
    body: isFormData ? body : JSON.stringify(body),
    headers: {
      ...contentType,
      ...headers,
    },
    method,
    ...rest,
  });

  return await response.json();
}

const authenticatedFetch = (function () {
  let authHeaders: { Authorization: string };

  return {
    prepareHeaders: ({ token }: TokenResponse) => {
      authHeaders = {
        Authorization: `Bearer ${token}`,
      };
    },
    fetchJSON: async <T, E = ErrorResponse>(
      route: string,
      options: any = {}
    ): Promise<T | E> => {
      const headers = {
        ...options.headers,
        ...authHeaders,
      };
      return await fetchJSON(route, { ...options, headers });
    },
  };
})();

export { fetchJSON, authenticatedFetch };
